import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { addWalletValidity } from '../../../redux/wallet/action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const durationTypeOptions = [
  { value: '1', label: 'Unlimited' },
  { value: '2', label: 'Days' },
  { value: '3', label: 'Weeks' },
  { value: '4', label: 'Months' },
  { value: '5', label: 'Years' }
];

const validationSchema = Yup.object().shape({
  duration_type: Yup.string().required('Duration type is required'),
  duration: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === '' ? null : value
    )
    .when('duration_type', {
      is: (val) => val !== '1',
      then: (schema) =>
        schema
          .typeError('Duration must be a number')
          .positive('Duration must be greater than 0')
          .required('Duration is required'),
      otherwise: (schema) => schema.notRequired()
    })
});


const CreateWalletValidities = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      duration_type: '',
      duration: ''
    },
    validationSchema,
    onSubmit: values => {
      handleSubmit(values)
    }
  });


  const handleSubmit = async (values) => {
      const data = {
        ...values,
      };
      dispatch(addWalletValidity(data, setLoading, navigate));
    };



  const selectedDurationType = durationTypeOptions.find(
    option => option.value === formik.values.duration_type
  );

  return (
    <div className="card-head p-4 order-card order-timing">
      <form onSubmit={formik.handleSubmit}>

        {/* Duration Type */}
        <div className="mb-3">
          <label className="form-label">Duration Type</label>
          <Select
            options={durationTypeOptions}
            value={selectedDurationType}
            onChange={selectedOption =>
              formik.setFieldValue('duration_type', selectedOption.value)
            }
            onBlur={() => formik.setFieldTouched('duration_type', true)}
            placeholder="Select Duration Type"
          />
          {formik.touched.duration_type && formik.errors.duration_type && (
            <div className="text-danger">{formik.errors.duration_type}</div>
          )}
        </div>

        {/* Duration Input */}
        <div className="mb-3">
          <label htmlFor="duration" className="form-label">Duration</label>
          <input
            type="number"
            id="duration"
            name="duration"
            className="form-control"
            value={formik.values.duration}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={formik.values.duration_type === '1'}
            min="1"
          />
          {formik.touched.duration && formik.errors.duration && (
            <div className="text-danger">{formik.errors.duration}</div>
          )}
        </div>

        <button type="submit" className="btn btn-primary">Submit</button>
      </form>
    </div>
  );
};

export default CreateWalletValidities;
